import React, { Component } from 'react';

import { TextField } from 'react-md';

export default class HasQualifierSlide extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

    }

    render() {

        let yesClass = this.props.value ? 'gc-hasqualifier-button gc-button--active' : 'gc-hasqualifier-button';
        let noClass = !this.props.value ? 'gc-hasqualifier-button gc-button--active' : 'gc-hasqualifier-button';
        let yesOptionStyle = { left: '1rem' };
        let noOptionStyle = { left: '50%' };

        let lrPosition = this.props.position < this.props.slideNumber ? '-100vw' : this.props.position > this.props.slideNumber ? '100vw' : '0vw';
        let cardHeight = this.props.position === this.props.slideNumber ? 10 : 0;

        return (
            <div className={"gc-slide"} style={{ left: lrPosition, overflow: "hidden", height: cardHeight + 'rem' }}>
                <div className="gc-question hasqualifier">{"Does your contest have a qualifier metric?"}</div>
                <div className={yesClass} style={yesOptionStyle} onClick={this.props.onSelect.bind(null, true)}>{"Yes"}</div>
                <div className={noClass} style={noOptionStyle} onClick={this.props.onSelect.bind(null, false)}>{"No"}</div>
            </div>
        );
    }
}